<template>
  <a
    href="#"
    class="info-icon-wrap"
    @click.prevent.stop="open"
  >
    <span class="visually-hidden">
      open infoblock
    </span>

    <span
      :class="{'info-icon--white': isWhiteIcon}"
      class="info-icon"
    />
  </a>
</template>

<script>
import PubSub from '@helper/PubSub'

export default {
  name: 'InfoIcon',
  props: {
    infoText: {
      type: String,
      required: true,
    },
    isWhiteIcon: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    open () {
      PubSub.publish('show-popup', {
        text: this.infoText,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
  @import "styles/index";
</style>
